module.exports = __webpack_public_path__ + "school/img/person.e53982bd.png";